export default "__VITE_ASSET__frV1oM3A__"